import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const detailRow = (index: number): SxStyle => ({
  padding: (p) => p.spacing(1),
  backgroundColor: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(0.5),
});

export const grid: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const disabledCheckIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
